export * from './useTotalsQuery.types';
export { default as useTotalsQuery } from './useTotalsQuery';
